import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button, FormHelperText, Grid, Modal } from "@mui/material";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import axios from "axios";
import AlertMessage from "./child-components/AlertMessages";
import BulkUploadJobs from "./child-components/BulkUploadJobs";
import useBulkUploadJobs from "./useBulkUploadJobs";
import BulkDownload from "../bulk-download";
import flightsampledata from "../../../assets/sample-data/FlightshopSampleData.xlsx";
import guidelinePDFfile from "../../../assets/viz-guidelines/BulkUploadguidelines.pdf";
import APIServices from "../../../services/api-services";
import { isValue, type } from "../../../utils/constants/constants";
import "./bulkimport.scss";
import {
  AirlineAlertTXT,
  AirlineErrTxt,
  GroupInShopErrTxt,
} from "../../../utils/constants/htmlConstants";
import { clearAllReduxStates } from "../../../utils/common-hooks/clearState";
import { persistor } from "../../../store/store";
import Spinner from "../../../layout/spinner/spinner";
import { ADD_FIGHT_SHOP_FORM } from "../../../utils/constants/inputFieldConstants";
import { setLogoutSession } from "../../../services/slices/authTokenSlice";
import {
  responseData,
} from "../../../utils/helpers/helper";
import { reSetMyMarketFilterFormData } from "../../../services/slices/filterFormDatas";
import { removeChartGroupShopContent } from "../../../utils/helpers/helper";

const defaultPayload = {
  rateparityData: false,
  historicalData: false,
  historicalHorizon: "",
  metaSources: [],
  otaSources: [],
};

const BulkImport = (props) => {
  const { uploadType, table, isShowinsert, setIsShowinsert, isShowDownload, setIsShowDownload } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const deleteController = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [error, setError] = useState(isValue?.emptyString);
  const [bulkImportResponse, setBulkImportResponse] = useState(null);
  const [libraryCondition, setLibraryCondition] = useState({});
  const [errored, setErrored] = useState(null);
  const [alertMessageProps, setAlertMessageProps] = useState({
    open: false,
    onClose: () => { },
    header: isValue?.emptyString,
    body: () => { },
    footer: () => { },
  });
  const fileInputRef = useRef(null);
  const myMarketPayload = {
    shopName: isValue?.emptyString,
    flyFrom: isValue?.emptyString,
    flyTo: isValue?.emptyString,
    frequency: [],
    status: 1,
    cabinClass: isValue?.emptyString,
    page: 1,
    pageSize: 100,
    routeType: 0,
    pos: isValue?.emptyString,
    currency: isValue?.emptyString,
    maxStops: isValue?.emptyString,
    maxDuration: isValue?.emptyString,
    sources: isValue?.emptyString,
    visualizeOnly: false,
    nonvisualizeOnly: false,
    groupShops: [],
  };
  const {
    fetchMyMarket,
    userAirlineData,
    getSources,
    fetchMarketGroup,
    deleteBulkMyMarket,
    bulkShopWithLibrary,
  } = APIServices();
  const fetchMyMarketController = useRef(null);
  const fetchMarketGroupController = useRef(null);
  const samplefile = flightsampledata;
  const guidelinefile = guidelinePDFfile;
  const sampledatafilename = "FlightSampleData.xlsx";
  const sapmpleguidelinefilename = "BulkUploadGuidelines.pdf";
  const { downloading } = useSelector((state) => state?.MyMarket);
  const [loading, setLoading] = useState(false);
  const getSourcesAll = useRef(null);
  const [historicalDataOpenModal, setHistoricalDataOpenModal] = useState(false);
  const [requiredPayload, setRequiredPayload] = useState(defaultPayload);
  const [ratepatiryDataOpen, setRatepatiryDataOpen] = useState(false);
  const [historicalDataOpen, setHistoricalDataOpen] = useState(false);
  const [metaOTADataOpen, setMetaOTADataOpen] = useState(false);
  const [metaOTADataOpenModal, setMetaOTADataOpenModal] = useState(false);
  const [requiredErrMsg, setRequiredErrMsg] = useState("");
  const [requiredErr, setRequiredErr] = useState(false);
  const { source = [] } = useSelector((state) => state?.source?.sourceDatas);
  const bulkWithLibraryControl = useRef(null);
  const [getGroups, setGetGroups] = useState(false);
  // Files are queued and processed in the background (results open here when done), unless
  // REACT_APP_BULK_INSERT_ASYNC=false or the API has background uploads switched off (it answers 404: one-request upload)
  const backgroundUploads = process.env.REACT_APP_BULK_INSERT_ASYNC !== "false";
  const bulkJobs = useBulkUploadJobs({
    enabled: backgroundUploads,
    onResult: showUploadResult,
    onFailed: showUploadError,
    onUnauthorized: handleUnauthorized,
  });
  const queueUploads = backgroundUploads && bulkJobs.available;
  const uploadInProgress = queueUploads && bulkJobs.inProgress;
  // The progress shows inside the upload section (the rest of the page stays usable): open it while an upload runs
  useEffect(() => {
    if (uploadInProgress && !isShowinsert) setIsShowinsert(true);
  }, [uploadInProgress, isShowinsert, setIsShowinsert]);
  const marketGroupPayload = {
    groupName: isValue?.emptyString,
    market: isValue?.emptyString,
  };

  useEffect(() => {
    if (bulkImportResponse) {
      handleBulkResponse(bulkImportResponse, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bulkImportResponse]);

  const handleUpload = (file) => {
    const fileNameParts = file.name.split(".");
    const fileExtension = fileNameParts[fileNameParts.length - 1].toLowerCase();

    if (fileExtension === "xlsx" || fileExtension === "xls") {
      setUploadedFile(file);
      setError(isValue?.emptyString);
    } else {
      // The earlier choice is dropped too: otherwise its name stays on screen and Upload would send it
      setUploadedFile(null);
      setError("Please upload a valid .xlsx or .xls file.");
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const file = e.dataTransfer.files[0];
    handleUpload(file);
  };

  const handleFileInput = (e) => {
    const file = e.target.files[0];
    handleUpload(file);
  };

  const preventDefault = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  // Handle bulk shops insert/edit/delete
  const handleBulkRequest = async (e, updateairline, removeGroups = false) => {
    if (!uploadedFile) {
      setError("Please select your XLSX file.");
      return;
    }

    const formData = new FormData();
    formData.append("xlsx", uploadedFile);
    formData.append("fileName", uploadedFile.name);
    formData.append("updateAirline", updateairline);
    formData.append("removeGroups", removeGroups);
    const config = {
      headers: {
        Accept: "application/json",
      },
    };
    let url = `${process.env.REACT_APP_API_URL}${"market/bulkinsert"}`;

    if (uploadType === "flight") {
    }

    setGetGroups(removeGroups);

    try {
      setLoading(true);
      if (queueUploads) {
        // Queued: the result opens on this page when the upload has finished (useBulkUploadJobs)
        try {
          await bulkJobs.submit(formData);
          setLoading(false);
          return;
        } catch (error) {
          // 404: background uploads are off on the API: send the file the one-request way below
          if (error?.response?.status !== 404) throw error;
        }
      }
      const responses = await axios.post(url, formData, config);
      const response = await responseData(responses);
      if (responses.status === 200) {
        setLibraryCondition(response?.chartDetails);
        setBulkImportResponse(response);
        setErrored(response?.errored);
        if (updateairline) {
          await userAirlineData(
            fileInputRef,
            () => { },
            () => { }
          );
        }
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      showUploadError(error?.response);
      handleUnauthorized(error?.response);
    }
  };

  // The error dialog of an upload (also for a background upload whose checks failed: same messages)
  function showUploadError(errorResponse) {
    setAlertMessageProps({
      open: true,
      onClose: () =>
        setAlertMessageProps((prev) => {
          return { ...prev, ...{ open: false } };
        }),
      header: generateCommonModalTitle(
        responseData(errorResponse)?.message === AirlineErrTxt
          ? "renderMymarket"
          : "",
        "Bulk Upload Error"
      ),
      body: (
        <>
          {(() => {
            const msg = responseData(errorResponse)?.message;
            if (!msg) return <p>Please try again.</p>;
            if (msg === GroupInShopErrTxt) {
              return (
                <>
                  <p>{removeChartGroupShopContent?.[1]?.modalContent}</p>
                  <p>{removeChartGroupShopContent?.[2]?.modalContentTwo}</p>
                </>
              );
            }
            return <p>{msg === AirlineErrTxt ? AirlineAlertTXT : msg}</p>;
          })()}
        </>
      ),
      footer:
        responseData(errorResponse)?.message === AirlineErrTxt ||
          responseData(errorResponse)?.message === GroupInShopErrTxt ? (
          <div className="d-flex">
            <Button
              className="cancel-button"
              onClick={() =>
                setAlertMessageProps((prev) => {
                  return { ...prev, ...{ open: false } };
                })
              }
            >
              Cancel
            </Button>
            <Button
              className="secondary_button"
              onClick={(e) => {
                handleBulkRequest(
                  e,
                  true,
                  responseData(errorResponse)?.message ===
                  GroupInShopErrTxt
                );
                setAlertMessageProps((prev) => {
                  return { ...prev, ...{ open: false } };
                });
              }}
            >
              OK
            </Button>
          </div>
        ) : (
          <Button
            className="secondary_button"
            onClick={() =>
              setAlertMessageProps((prev) => {
                return { ...prev, ...{ open: false } };
              })
            }
          >
            OK
          </Button>
        ),
    });
  }

  // 401: another login (logout dialog) or the session ended (back to the login page)
  function handleUnauthorized(errorResponse) {
    if (
      errorResponse?.status === 401 &&
      responseData(errorResponse)?.message === "New login found."
    ) {
      dispatch(setLogoutSession(true));
    } else if (errorResponse?.status === 401) {
      clearAllReduxStates(dispatch);
      persistor.purge();
      sessionStorage.clear();
      localStorage.clear();
      navigate("/");
    }
  }

  // A finished background upload: the same results screen as a one-request upload
  function showUploadResult(response, { updateAirline = false, state } = {}) {
    setLibraryCondition(response?.chartDetails);
    setBulkImportResponse(response);
    setErrored(response?.errored);
    if (state === "partial" && response?.incomplete?.message) bulkJobs.setMessage(response.incomplete.message);
    if (updateAirline) userAirlineData(fileInputRef, () => { }, () => { });
  }

  const generateCommonModalContent = (data, type) => {
    let temp = {
      ...(type !== "delete" && {
        ...(data?.totalShops && {
          "Requested Shops :": <p>{`Requested Shops :${data?.totalShops}`}</p>,
        }),
        ...(data?.sameShops && {
          "Same Shops : ": (
            <p className="clr-green"> {`Same Shops : ${data?.sameShops}`}</p>
          ),
        }),
        ...(data?.editedShops && {
          "Edited Shops : ": (
            <p className="clr-green">{`Edited Shops : ${data?.editedShops}`}</p>
          ),
        }),
        ...(data?.editedShopsFsid?.length > 0 && {
          "Edited Shop ids (reference fsids) : ": (
            <p className="clr-red">
              Edited Shop ids (reference fsids) :{" "}
              <span className="missing-shops">
                {data?.editedShopsFsid?.join(",")}
              </span>
            </p>
          ),
        }),
        ...(data?.inserted && {
          "New Shops : ": (
            <p className="clr-green">{`New Shops : ${data?.inserted}`}</p>
          ),
        }),
        ...(data?.successful && {
          "New Shops : ": (
            <p className="clr-green">{`Successfully Inserted : ${data?.successful}`}</p>
          ),
        }),
        ...(data?.errored && {
          "Failed Shops: ": (
            <p className="clr-red">{`Failed Shops : ${data?.errored}`}</p>
          ),
        }),
      }),
      ...(type === "delete" && {
        "Consirmation Content": (
          <p>
            Following shops are missing. Do you want to <b>delete</b> them?
          </p>
        ),
        "Missing Shop ids count": (
          <p>
            Missing Shop ids count : <b>{data?.missingFsids?.length}</b>
          </p>
        ),
        "Missing ids": (
          <p>
            Missing Shop ids :{" "}
            <span className="missing-shops">
              {data?.missingFsids?.join(",")}
            </span>
          </p>
        ),
      }),
    };

    return Object.values(temp).map((i) => i);
  };
  const redirectMymarket = async () => {
    setAlertMessageProps((prev) => {
      return { ...prev, ...{ open: false } };
    });
    if (uploadType === "flight") {
      dispatch(reSetMyMarketFilterFormData());
      navigate("/shop_manager", { state: { from: "mymymarket" } });
      await fetchMyMarket(
        myMarketPayload,
        fetchMyMarketController,
        () => { },
        () => { }
      );
      if (getGroups) {
        setGetGroups(false);
        await fetchMarketGroup(
          marketGroupPayload,
          fetchMarketGroupController,
          () => { },
          () => { }
        );
      }
      await getSources(
        getSourcesAll,
        () => { },
        () => { }
      );
    }
  };

  const generateCommonModalFooter = (type, erroredData) => {
    const errordata = erroredData?.flat(1);
    const isError = type === "error";
    const isDelete = type === "delete";
    const isSuccess = type === "success";
    return (
      <>
        {
          isError && (
            <BulkDownload
              type={"error"}
              fileName={"Bulk_Error_Report.xlsx"}
              errorData={errordata}
              setIsLoading={setIsLoading}
              setAlertMessagePropss={setAlertMessageProps}
              onDownloadComplete={(e) => {
                setTimeout(() => {
                  setIsLoading(false);
                  if (
                    uploadType === "flight" &&
                    (parseInt(bulkImportResponse?.inserted) > 0 ||
                      parseInt(bulkImportResponse?.editedShopsFsid?.length) > 0)
                  ) {
                    redirectMymarket(e);
                  }
                  if (
                    uploadType !== "flight" &&
                    (parseInt(bulkImportResponse?.inserted) > 0 ||
                      parseInt(bulkImportResponse?.editedShopsFsid?.length) > 0)
                  ) {
                    redirectMymarket(e);
                  }
                }, [500]); // Update isDownloaded when download is complete
                setIsLoading(false);
              }}
            />
          )
          // </Button>
        }

        {isDelete && (
          <>
            <Button
              className="secondary_button"
              onClick={(e) => deleteMissingShops(e, erroredData)}
            >
              Yes
            </Button>
            <Button
              className="cancel-button"
              onClick={(e) => notToDeleteMissingShops(e, erroredData)}
            >
              No
            </Button>
          </>
        )}
        {isSuccess && (
          <Button
            className="secondary_button"
            onClick={(e) => redirectMymarket(e)}
          >
            Ok
          </Button>
        )}
      </>
    );
  };

  const deleteMissingShops = async (e, erroredData) => {
    setAlertMessageProps((prev) => {
      return { ...prev, ...{ open: false } };
    });
    e.preventDefault();
    const payload = {
      fsIds: bulkImportResponse?.missingFsids,
    };

    try {
      const res = await deleteBulkMyMarket(
        payload,
        deleteController,
        setIsLoading,
        setError
      );
      const modalType = errored > 0 ? "error" : "success";
      const modalFooter = generateCommonModalFooter(modalType, erroredData);
      const deleteCOntent = (
        <p className="clr-red">{`Deleted Shops : ${bulkImportResponse?.missingFsids?.length || 0
          }`}</p>
      );

      if (res?.message === "Successfully Deleted") {
        setIsLoading(true);
        let temp = [
          ...generateCommonModalContent(bulkImportResponse, modalType),
          deleteCOntent,
        ];
        await fetchMyMarket(
          myMarketPayload,
          fetchMyMarketController,
          () => { },
          () => { }
        );

        await fetchMarketGroup(
          marketGroupPayload,
          fetchMarketGroupController,
          () => { },
          () => { }
        );

        const { needHistorical, needMetasource, needOtasMetasource } =
          libraryCondition || {};
        setIsLoading(false);
        if (needMetasource) {
          setRatepatiryDataOpen(true);
          setHistoricalDataOpen(needHistorical ? true : false);
        } else if (needHistorical && !needMetasource) {
          setHistoricalDataOpenModal(true);
          setMetaOTADataOpen(needOtasMetasource ? true : false);
        } else if (needOtasMetasource && !needMetasource && !needHistorical) {
          setMetaOTADataOpenModal(true);
        } else {
          setAlertMessageProps({
            open: true,
            onClose: () =>
              setAlertMessageProps((prev) => {
                return {
                  ...prev,
                  ...{ open: modalType === "error" ? true : false },
                };
              }),
            header: generateCommonModalTitle(
              modalType === "success" ? "renderMymarket" : "",
              "Bulk Insert Reports",
              modalType
            ),
            body: temp,
            footer: modalFooter,
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const notToDeleteMissingShops = (e, erroredData) => {
    const modalType = errored > 0 ? "error" : "success";
    const modalBody = generateCommonModalContent(bulkImportResponse, modalType);
    const modalFooter = generateCommonModalFooter(modalType, erroredData);
    setAlertMessageProps({
      open: true,
      onClose: () =>
        setAlertMessageProps((prev) => {
          return { ...prev, ...{ open: modalType === "error" ? true : false } };
        }),
      header: generateCommonModalTitle(
        modalType === "success" ? "renderMymarket" : "",
        "Bulk Insert Report",
        modalType
      ),
      body: modalBody,
      footer: modalFooter,
    });
  };

  const handleBulkResponse = async (data, step) => {
    if (data && bulkImportResponse) {
      let isFsidMissing = data?.missingFsids?.length > 0;
      let isShopsCreated = data?.message === "Shops Created!";
      let isShopErrored = data?.errored > 0;
      if (!data?.error) {
        const { needHistorical, needMetasource, needOtasMetasource } = !step
          ? libraryCondition
          : {};
        if (isShopsCreated && !isShopErrored) {
          const modalType = isFsidMissing && !step ? "delete" : "success";
          const modalBody = generateCommonModalContent(data, modalType);
          const modalFooter = generateCommonModalFooter(modalType);
          if (isFsidMissing && !step) {
            setAlertMessageProps({
              open: true,
              onClose: () =>
                setAlertMessageProps((prev) => {
                  return {
                    ...prev,
                    ...{ open: modalType === "error" ? true : false },
                  };
                }),
              header: generateCommonModalTitle(
                modalType === "success" ? "renderMymarket" : "",
                "Bulk Insert Report",
                modalType
              ),
              body: modalBody,
              footer: modalFooter,
            });
          } else {
            if (needMetasource) {
              setRatepatiryDataOpen(true);
              setHistoricalDataOpen(needHistorical ? true : false);
            } else if (needHistorical && !needMetasource) {
              setHistoricalDataOpenModal(true);
              setMetaOTADataOpen(needOtasMetasource ? true : false);
            } else if (
              needOtasMetasource &&
              !needMetasource &&
              !needHistorical
            ) {
              setMetaOTADataOpenModal(true);
            } else {
              setAlertMessageProps({
                open: true,
                onClose: () =>
                  setAlertMessageProps((prev) => {
                    return {
                      ...prev,
                      ...{ open: modalType === "error" ? true : false },
                    };
                  }),
                header: generateCommonModalTitle(
                  modalType === "success" ? "renderMymarket" : "",
                  "Bulk Insert Report",
                  modalType
                ),
                body: modalBody,
                footer: modalFooter,
              });
            }
          }
        } else if (isShopsCreated && isShopErrored) {
          const modalType = isFsidMissing && !step ? "delete" : "error";
          const modalBody = generateCommonModalContent(data, modalType);
          let errorData = data?.errors?.map((i) => {
            return i.shopInfo.map((info) => {
              if (uploadType === "flight") {
                return {
                  status: info.status || null,
                  Shopname: info.shopName || null,
                  Origin: info.origin || null,
                  Destination: info.destination || null,
                  // "Need Deepsearch":
                  //   info.isDeepsearch === true ||
                  //   info?.isDeepsearch === "Yes" ||
                  //   info?.isDeepsearch === "true"
                  //     ? "Yes"
                  //     : "No",
                  "Primary Airline": info.primaryAirline || null,
                  Brands: info.carriers || null,
                  OTAs: info.sources || null,
                  "Sabre": info?.sabreOtas || null,
                  "Need Travelport":
                    info.isTravelportGds === true ||
                      info?.isTravelportGds === "Yes"
                      ? "Yes"
                      : "No",
                  "Need Ancillary":
                    info.isAncillary === true ||
                    info?.isAncillary === "Yes" ||
                    info?.isAncillary === "yes" ||
                    info?.isAncillary === "true"
                      ? "Yes"
                      : "No",
                  "Add rate parity": info.rateparityData || null,
                  "Route Type": (info.tripType === 0 || info.tripType) ? info.tripType.toString() : null,
                  Los: (info.los === 0 || info.los) ? info.los.toString() : null,
                  "Cabin class": info.cabinClass || null,
                  Adults: (info.adults === 0 || info.adults) ? info.adults.toString() : null,
                  infants: info.infants || 0,
                  Pos: info.pos || null,
                  Currency: info.currency || null,
                  "Max Stops":
                    info?.maxStops === -1 || info?.maxStops === "-1"
                      ? "All"
                      : info?.maxStops === 0 || info?.maxStops === "0"
                        ? "0"
                        : info?.maxStops || null,
                  "Max Duration":
                    info?.maxDuration === -1 || info?.maxDuration === "-1"
                      ? "All"
                      : info?.maxDuration || null,
                  "Specific Custom Horizon Days": info?.customHorizon || null,
                  "Horizon days":
                    info.horizonDays?.length > 1 &&
                      typeof info.horizonDays !== "string"
                      ? info.horizonDays?.join(",")
                      : info.horizonDays || null,
                  "Horizon Start Date": info.horizonStartDate || null,
                  "Horizon End Date": info.horizonEndDate || null,
                  Frequency: info.frequency || null,
                  Days:
                    info.frequency?.refresh === "Custom"
                      ? info.frequency?.customFrequency
                        .filter((datares) => datares.days.length > 0)
                        .map((res) => `(${[res.days]})`)
                        .toString()
                      : info.frequency?.days?.length > 1
                        ? info.frequency?.days?.join(",")
                        : info.frequency?.days || null,
                  "Frequency custom week": info.frequencyCustomWeek || null,
                  "Frequency custom month": info.frequencyCustomMonth || null,
                  "Delivery time": info.deliveryTime || null,
                  "Startdate of shop": info.shopStartDate || null,
                  "End Date of shop": info.shopEndDate || null,
                  "Add historical": info.historicalData || null,
                  "Price Evolution Horizon": info.historicalHorizon || 0,
                  Charts: info.charts || null,
                  "Error Message":
                    typeof i.message === "string"
                      ? i.message
                      : i.message?.join("\n"),
                };
              } else {
                return {
                  Shopname: info.Shopname || null,
                  Origin: info.Origin || null,
                  Destination: info.Destination || null,
                  Airline: info.Airline || isValue?.emptyString,
                  AirlineIATA: info.AirlineIATA || isValue?.emptyString,
                  "Cabin class": info.Cabinclass || null,
                  Pos: info.Pos || null,
                  Currency: info.Currency || null,
                  Stops:
                    info.Stops !== undefined
                      ? typeof info.Stops === type?.string ||
                        typeof info.Stops === type?.number
                        ? parseInt(info.Stops)
                        : parseInt(info.Stops?.join(","))
                      : " " ?? " ",
                  Codeshareflight: info.codeshareflights
                    ? info.codeshareflights
                    : isValue?.emptyString || null,
                  "Error Message":
                    typeof i.message === type?.string
                      ? i.message
                      : i.message?.join("\n"),
                };
              }
            });
          });
          const modalFooter = generateCommonModalFooter(modalType, errorData);
          if (isFsidMissing && !step) {
            setAlertMessageProps({
              open: true,
              onClose: () =>
                setAlertMessageProps((prev) => {
                  return {
                    ...prev,
                    ...{ open: modalType === "error" ? true : false },
                  };
                }),
              header: generateCommonModalTitle(
                "",
                "Bulk Insert Report",
                modalType
              ),
              body: modalBody,
              footer: modalFooter,
            });
          } else {
            if (needMetasource) {
              setRatepatiryDataOpen(true);
              setHistoricalDataOpen(needHistorical ? true : false);
            } else if (needHistorical && !needMetasource) {
              setHistoricalDataOpenModal(true);
              setMetaOTADataOpen(needOtasMetasource ? true : false);
            } else if (
              needOtasMetasource &&
              !needMetasource &&
              !needHistorical
            ) {
              setMetaOTADataOpenModal(true);
            } else {
              setAlertMessageProps({
                open: true,
                onClose: () =>
                  setAlertMessageProps((prev) => {
                    return {
                      ...prev,
                      ...{ open: modalType === "error" ? true : false },
                    };
                  }),
                header: generateCommonModalTitle(
                  "",
                  "Bulk Insert Report",
                  modalType
                ),
                body: modalBody,
                footer: modalFooter,
              });
            }
          }
        }
      } else {
        setAlertMessageProps({
          open: true,
          onClose: () =>
            setAlertMessageProps((prev) => {
              return { ...prev, ...{ open: false } };
            }),
          header: generateCommonModalTitle("", "Bulk Insert Report"),
          body: <p>{data?.message}</p>,
          footer: (
            <button
              className="secondary_button"
              onClick={() =>
                setAlertMessageProps((prev) => {
                  return { ...prev, ...{ open: false } };
                })
              }
            >
              OK
            </button>
          ),
        });
      }
    }
  };

  const handleshowinsert = () => {
    setIsShowinsert(!isShowinsert);
  };

  const handleshowDownload = () => {
    setIsShowDownload(!isShowDownload);
  };

  const generateBulkModalDetails = () => {
    if (uploadType === "flight") {
      return (
        <div className="bulk-request-template no-translate">
          <ul>
            <li>
              The first row must contain the column names <span>*</span>
            </li>
            <li>
              The column names must match the list below :
              <ol>
                <li>
                  Origin <span>*</span>
                </li>
                <li>
                  Destination <span>*</span>
                </li>
                {/* <li>
                  Deepsearch <span>*</span>
                </li> */}
                <span className="value-info">
                  Enter at least one brand or one OTA
                </span>
                <li>Brands (must be a number)</li>
                <li>OTAs (must be a number)</li>
                <li>
                  Route Type (must be a number)<span>*</span>
                  <ul className="sub-list">
                    <li>OW = 1</li>
                    <li>RT = 2</li>
                  </ul>
                </li>
                <li>
                  Los <span>*</span> (must be a number) -{" "}
                  <span> (Only if Route Type = RT) </span>
                </li>
                <li>
                  Cabin class (must be a number)<span>*</span>
                  <ul className="sub-list">
                    <li>Economy = 1</li>
                    <li>Business = 2</li>
                    <li>First Class = 3</li>
                    <li>Premium Economy= 4</li>
                  </ul>
                </li>
                <li>
                  Adults (must be a number)<span>*</span>
                </li>
                <li>
                  Infants (must be a number)<span>*</span>
                </li>
                <li>
                  Pos <span>*</span>
                </li>
                <li>
                  Currency <span>*</span>
                </li>
                <span className="value-info">
                  Insert dynamic horizons and up to 1 fix dates horizon [
                  <span className="blk-txt">
                    (1,2,6,30) and (0 to 30) and (90-120) and (2024-09-01 to
                    2024-12-31)
                  </span>
                  ]
                </span>
                <li>
                  Specific Custom Horizon Days (must be numbers with comma
                  seperated)
                </li>
                <li>Horizon start day (must be a number)</li>
                <li>Horizon end day (must be a number)</li>
                <li>Horizon Start Date (must be in the format - YYYY-MM-DD)</li>
                <li>Horizon End Date ( must be in the format - YYYY-MM-DD)</li>
                <li>
                  Frequency <span>*</span>
                  <ul className="sub-list">
                    <li>Daily</li>
                    <li>
                      Weekly
                      <ul className="sub-list">
                        <li>
                          <b>SUN</b> = 0
                        </li>
                        <li>
                          <b>MON</b> = 1
                        </li>
                        <li>
                          <b>TUE</b> = 2
                        </li>
                        <li>
                          <b>WED</b> = 3
                        </li>
                        <li>
                          <b>THU</b> = 4
                        </li>
                        <li>
                          <b>FRI</b> = 5
                        </li>
                        <li>
                          <b>SAT</b> = 6
                        </li>
                      </ul>
                    </li>
                    <li>
                      Monthly
                      <ul>
                        <li>
                          a) Days (Only if Frequency = Monthly (must be a number
                          From 1-31))
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <ul>
                    <li>
                      Custom
                      <ul>
                        <li>
                          b) Days (only if Frequency = Custom ( Weekly & Monthly
                          - must be a number))<span>*</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <span className="value-info">
                  In Custom Frequency, days and week fields should contain the
                  same set of values.
                </span>
                <ul className="m-b-5">
                  <li>Weekly - (0 to 6) --- Monthly - (1 to 31)</li>
                  <li className="red-txt">For Example: </li>
                  <li className="d-flex">
                    <div className="ex-custom red-txt">
                      Days = (0,1,2), (2,4,6), (0,4)
                    </div>{" "}
                    <div className="ex-custom red-txt">
                      Frequency custom week = 1,2,3
                    </div>{" "}
                  </li>
                  <li className="d-flex">
                    <div className="ex-custom red-txt">
                      Days = (0,1,2), (0,1,2){" "}
                    </div>
                    <div className="ex-custom red-txt">
                      Frequency custom week = 1,3
                    </div>
                  </li>
                </ul>
                <li>
                  Delivery time <span>*</span>
                  <ul>
                    <li>Ex: 4:30 am - UTC , 6:30 am - UTC</li>
                  </ul>
                </li>
                <li>
                  Start date of the shop (must be in the format - YYYY-MM-DD){" "}
                  <span>*</span>
                </li>
                <li>
                  End Date of the shop (must be in the format - YYYY-MM-DD){" "}
                  <span>*</span>
                </li>
                <li>
                  Shop name<span>*</span>
                </li>
                <li>Price Evolution Horizon (must be a number)</li>
                <li>Price Evolution refresh frequency</li>
                <li>Days (must be (Weekly) or (Monthly))</li>
                <li>
                  Price Evolution delivery time
                  <ul>
                    <li>Ex: 4:30 am - UTC , 6:30 am - UTC</li>
                  </ul>
                </li>
              </ol>
            </li>
          </ul>
          <p>
            Note: All the mandatory fields are marked with (
            <span className="red">*</span>)
          </p>
        </div>
      );
    } else {
      return (
        <div className="bulk-request-template no-translate">
          <ul>
            <li>
              The first row must contain the column names <span>*</span>
            </li>
            <li>
              The column names must match the list below :
              <ol>
                <li>
                  Origin <span>*</span>
                </li>
                <li>
                  Destination <span>*</span>
                </li>
                <li>
                  Target Airline <span>*</span>
                </li>
                <li>
                  Cabinclass (must be a number) <span>*</span>
                  <ul className="sub-list">
                    <li>Economy = 1</li>
                    <li>Business = 2</li>
                    <li>First Class = 3</li>
                    <li>Premium Economy = 4</li>
                  </ul>
                </li>
                <li>
                  Pos <span>*</span>
                </li>
                <li>
                  Currency <span>*</span>
                </li>
                <li>
                  Shopname <span>*</span>
                </li>
                <li>
                  Stops (must be a number) <span>*</span>
                  <ul className="sub-list">
                    <li>Non Stop = 0 </li>
                    <li>One Stop = 1 </li>
                    <li>Two Stops = 2</li>
                  </ul>
                </li>
                <li>
                  Codeshareflight <span>*</span>
                </li>
                <ul>
                  <li>YES</li>
                  <li>NO</li>
                </ul>
              </ol>
            </li>
          </ul>
          <p>
            Note: All the mandatory fields are marked with (
            <span className="red">*</span>)
          </p>
        </div>
      );
    }
  };

  const generateCommonModalTitle = (closetype, tilte, type) => {
    const isError = type === "error";
    const isredirect = closetype === "renderMymarket" ? true : false;
    return (
      <div className="d-flex justyfy-space-between title-modal">
        <h5>{tilte}</h5>
        {!isError && !isredirect && (
          <h3 onClick={() => handleDetailspopupclose()} className="cursor-p">
            +
          </h3>
        )}
      </div>
    );
  };

  const handleDetailspopupclose = () => {
    setAlertMessageProps((prev) => {
      return {
        ...prev,
        ...{
          open: false,
          header: isValue?.emptyString,
          body: isValue?.emptyString,
        },
      };
    });
  };

  const handleDetailsPopup = () => {
    setAlertMessageProps((prev) => {
      return {
        ...prev,
        ...{
          open: true,
          header: generateCommonModalTitle("", "Bulk Request Template Rules"),
          body: generateBulkModalDetails(),
        },
      };
    });
  };

  const browseButton = () => {
    fileInputRef.current.value = "";
    fileInputRef.current.click();
  };

  const handleRequiredClose = () => {
    setRequiredPayload(defaultPayload);
    setRatepatiryDataOpen(false);
    setHistoricalDataOpen(false);
    setMetaOTADataOpen(false);
    setHistoricalDataOpenModal(false);
    setMetaOTADataOpenModal(false);
  };

  const handleRequireOnchange = (e) => {
    if (e.target.name === "historical") {
      if (e.target.value !== "") {
        setRequiredPayload((prev) => ({
          ...prev,
          historicalHorizon: e.target.value,
          historicalData: true,
        }));
      } else {
        setRequiredPayload((prev) => ({
          ...prev,
          historicalHorizon: e.target.value,
          historicalData: false,
        }));
      }
      setRequiredErrMsg("");
    } else if (e.target.name === "metasource") {
      if (e.target.value !== "") {
        setRequiredPayload((prev) => ({
          ...prev,
          metaSources: [parseInt(e.target.value)],
        }));
      } else {
        setRequiredPayload((prev) => ({ ...prev, metaSources: [] }));
      }
    } else if (e.target.name === "ota") {
      if (e.target.value !== "") {
        setRequiredPayload((prev) => ({
          ...prev,
          otaSources: [parseInt(e.target.value)],
        }));
      } else {
        setRequiredPayload((prev) => ({ ...prev, otaSources: [] }));
      }
    }
  };

  const handleBulkWithLibrary = async (payload) => {
    const bulkPayload = !!payload ? payload : requiredPayload;
    const addBulkwithLibrary = await bulkShopWithLibrary(
      bulkWithLibraryControl,
      bulkPayload,
      setIsLoading,
      () => { }
    );
    if (addBulkwithLibrary?.message === "Flightshop updated!") {
      setLibraryCondition({});
      handleBulkResponse(bulkImportResponse, true);
    }
  };

  const handleAddedHistorical = async (e) => {
    if (
      requiredPayload?.historicalData &&
      requiredPayload?.historicalHorizon !== ""
    ) {
      if (metaOTADataOpen) {
        setHistoricalDataOpen(false);
        setRatepatiryDataOpen(false);
        setMetaOTADataOpen(false);
        setHistoricalDataOpenModal(false);
        setMetaOTADataOpenModal(true);
      } else {
        await handleBulkWithLibrary();
        handleRequiredClose();
      }
    } else {
      setRequiredErr(true);
      setRequiredErrMsg("Please select a valid Historical Horizon.");
    }
  };

  const handleAddedRateparity = async (e) => {
    const googleOTA = source?.filter((res) => res?.source === "Google")?.map((data) => data?.code);
    setRequiredPayload((prev) => ({
      ...prev,
      rateparityData: true,
      metaSources: googleOTA,
    }));
    const payload = {
      ...requiredPayload,
      rateparityData: true,
      metaSources: googleOTA,
    };
    if (historicalDataOpen) {
      setRatepatiryDataOpen(false);
      setHistoricalDataOpen(false);
      setHistoricalDataOpenModal(true);
    } else if (metaOTADataOpen) {
      setRatepatiryDataOpen(false);
      setMetaOTADataOpen(false);
      setHistoricalDataOpenModal(false);
      setMetaOTADataOpenModal(true);
    } else {
      await handleBulkWithLibrary(payload);
      handleRequiredClose();
    }
  };

  const handleAddedMetaSources = async (e) => {
    if (
      requiredPayload?.metaSources?.length ||
      requiredPayload?.otaSources?.length
    ) {
      await handleBulkWithLibrary();
      handleRequiredClose();
    } else {
      setRequiredErr(true);
      setRequiredErrMsg("Please select atleast one meta source or OTA.");
    }
  };

  return (
    <React.Fragment>
      {!!isLoading && <Spinner />}
      <div>
        <Grid
          container
          columns={{ xs: 4, sm: 6, md: 12 }}
          className="m-auto justyfy-center"
          onDrop={handleDrop}
          onDragOver={preventDefault}
        >
          <Grid
            item
            xs={8}
            className={`drag-box d-flex justify-center align-center `}
          >
            <div
              className={`w-55 ${isShowinsert ? "input-show-box" : "input-hide-box"
                }${uploadInProgress ? " input-show-box--progress" : ""}`}
            >
              <h5
                onClick={() => handleshowinsert()}
                className="d-flex align-center justyfy-center cursor-p"
              >
                Upload multiple {table}
                <span className="mt-3 ml-5">
                  {isShowinsert ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </span>
              </h5>
              <Box className="details-txt">
                <p className="text-center">
                  <a href={guidelinefile} download={sapmpleguidelinefilename}>
                    See the bulk upload guidelines
                  </a>
                </p>
                <p className="text-center">
                  <a href={samplefile} download={sampledatafilename}>
                    Sample upload file
                  </a>
                </p>
              </Box>
              {uploadedFile && (
                <p className="text-center file-name">{uploadedFile?.name}</p>
              )}
              {error && (
                <FormHelperText className="text-center err" error>
                  {error}
                </FormHelperText>
              )}
              <input
                className="d-none"
                type="file"
                accept=".xlsx, .xls"
                onChange={handleFileInput}
                ref={fileInputRef}
              />
              <div className="d-grid justyfy-center">
                <Button onClick={browseButton} className="secondary_button">
                  Browse file
                </Button>
                <Button
                  onClick={(e) => handleBulkRequest(e, false)}
                  disabled={loading || uploadInProgress}
                  className="primary_button"
                >
                  {!loading && !uploadInProgress ? `Upload ${table}` : "Uploading..."}
                </Button>
              </div>
              {queueUploads && (
                // This user's upload: its progress here, under the (disabled) upload button. The rest of the page,
                // such as adding a shop by hand, stays usable; the result opens here when the upload has finished.
                <>
                  {!uploadInProgress && bulkJobs.message && (
                    <FormHelperText className="text-center err" error>{bulkJobs.message}</FormHelperText>
                  )}
                  {uploadInProgress && (
                    <Box className="bulk-upload-progress" aria-live="polite">
                      <BulkUploadJobs
                        current={{
                          active: bulkJobs.current.active?.submittedByMe ? bulkJobs.current.active : null,
                          queued: bulkJobs.current.queued.filter((job) => job.submittedByMe),
                          unacknowledged: [],
                        }}
                        reconnecting={bulkJobs.reconnecting}
                        message={bulkJobs.message}
                      />
                    </Box>
                  )}
                </>
              )}
            </div>
          </Grid>
        </Grid>
      </div>

      {(downloading && uploadType === "flight") ? (
        <>
          <div className="mtb-10">
            <p>OR</p>
          </div>
          <div>
            <Grid
              container
              columns={{ xs: 4, sm: 6, md: 12 }}
              className="m-auto justyfy-center"
              onDrop={handleDrop}
              onDragOver={preventDefault}
            >
              <Grid
                item
                xs={8}
                className={`drag-box d-flex justify-center align-center `}
              >
                <div
                  className={`w-55 ${isShowDownload ? "input-show-box" : "input-hide-box"
                    }`}
                >
                  <h5
                    onClick={() => handleshowDownload()}
                    className="d-flex align-center justyfy-center cursor-p"
                  >
                    Modify your existing {table}{" "}
                    <span className="mt-3 ml-5">
                      {isShowDownload ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </span>
                  </h5>
                  <Box className="Modify-details-txt">
                    <p>
                      1.{" "}
                      <BulkDownload
                        type={
                          "rateshop"
                        }
                        fileName={"My Market Shops.xlsx"}
                      />{" "}
                      the current {table} file.
                    </p>
                    <p>2. Modify it:</p>
                    <ul>
                      <li>
                        <p>
                          To delete a {table}, delete the corresponding line{" "}
                        </p>
                      </li>
                      <li>
                        <p>To modify a {table}, edit the corresponding line </p>
                      </li>
                    </ul>
                    <p>3. Upload the edited file in the section above.</p>
                  </Box>
                </div>
              </Grid>
            </Grid>
          </div>
        </>
      ) : (
        <></>
      )}
      <AlertMessage {...alertMessageProps} />

      <Modal
        backdrop={"static"}
        open={!!historicalDataOpenModal}
        className="common-modal no-translate required-modal"
      >
        <Box className="modal-box create-dashboard-modal">
          <div className="modal-header">
            <h3> Chart Requirement</h3>
            <Button onClick={() => handleRequiredClose()}>
              <span>+</span>
            </Button>
          </div>
          <p>
            It looks like some of your shops don't have the required historical
            data for the Chart Set. To add this chart, please specify the range
            of historical data to include for all applicable shops.
          </p>
          <h4>
            Set historical horizon to :
            <select
              className="required-select"
              name="historical"
              value={requiredPayload?.historicalHorizon}
              onChange={handleRequireOnchange}
            >
              <option value="">Select Horizon</option>
              {
                // eslint-disable-next-line array-callback-return
                ADD_FIGHT_SHOP_FORM?.PRICEEVOLUTION?.options?.map(
                  (res, index) => {
                    if (res !== "0") {
                      return (
                        <option key={index} value={res}>
                          {res}
                        </option>
                      );
                    } else {
                      return ""
                    }
                  }
                )
              }
            </select>{" "}
            days
          </h4>
          {!!requiredErr && <p className="err">{requiredErrMsg}</p>}
          <button
            type="submit"
            className="group-submit-btn"
            onClick={(e) => handleAddedHistorical(e)}
          >
            {metaOTADataOpen ? "Add to continue" : "Add to Dashboard"}
          </button>
        </Box>
      </Modal>

      <Modal
        backdrop={"static"}
        open={!!ratepatiryDataOpen}
        className="common-modal no-translate required-modal"
      >
        <Box className="modal-box create-dashboard-modal">
          <div className="modal-header">
            <h3> Chart Requirement</h3>
            <Button onClick={() => handleRequiredClose()}>
              <span>+</span>
            </Button>
          </div>
          <p>It looks like some of your shops don't have the Google data required for the Chart Set. We will include Google data for all shops in your dashboard to add this Chart Set.</p>
          <h4>Would you like to continue?</h4>
          <button
            type="submit"
            className="group-submit-btn"
            onClick={(e) => {
              handleAddedRateparity(e);
            }}
          >
            {historicalDataOpen ? "Add to continue" : "Add to Dashboard"}
          </button>
        </Box>
      </Modal>

      <Modal
        backdrop={"static"}
        open={!!metaOTADataOpenModal}
        className="common-modal no-translate required-modal"
      >
        <Box className="modal-box create-dashboard-modal">
          <div className="modal-header">
            <h3> Chart Requirement</h3>
            <Button onClick={() => handleRequiredClose()}>
              <span>+</span>
            </Button>
          </div>
          <p>
            It looks like the Chart Set requires data from OTAs or Metasources,
            but some of your shops currently only have data from Brand.com
            sources. Please select the OTAs or Metasources to include for all
            applicable shops.
          </p>
          <h4>
            Select a Metasource:
            <select
              className="required-select"
              name="metasource"
              onChange={handleRequireOnchange}
            >
              <option value="">Select Metasource</option>
              {
                // eslint-disable-next-line array-callback-return
                source?.map((res, index) => {
                  if (res?.sourceType === "Metasource") {
                    return (
                      <option key={index} value={res?.code}>
                        {res?.source}
                      </option>
                    );
                  }
                })
              }
            </select>
          </h4>
          <p>(or)</p>
          <h4>
            Select an OTA:
            <select
              className="required-select"
              name="ota"
              onChange={handleRequireOnchange}
            >
              <option value="">Select OTA</option>
              {
                // eslint-disable-next-line array-callback-return
                source?.map((res, index) => {
                  if (res?.source !== "Google" && res?.sourceType === "OTA") {
                    return (
                      <option key={index} value={res?.code}>
                        {res?.source}
                      </option>
                    );
                  }
                })
              }
            </select>
          </h4>
          {!!requiredErr && <p className="err">{requiredErrMsg}</p>}
          <button
            type="submit"
            className="group-submit-btn"
            onClick={(e) => handleAddedMetaSources(e)}
          >
            Add to Dashboard
          </button>
        </Box>
      </Modal>
    </React.Fragment>
  );
};

export default BulkImport;
